import React from "react";
import PropTypes from "prop-types";
import { Switch } from "@mui/material";

import "./CustomSwitch.scss";

function CustomSwitch({ checked, onChange, disabled, name, ...rest }) {
  return (
    <div className="custom-switch">
      <Switch checked={checked} onChange={onChange} disabled={disabled} name={name} {...rest} />
    </div>
  );
}

CustomSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  name: PropTypes.string,
};

CustomSwitch.defaultProps = {
  disabled: false,
  name: "",
};

export default CustomSwitch;
